import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Tag, TagType } from 'app/shared/models/class/tags/tag';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TagService {

  constructor(
    private http: HttpClient
  ) { }


  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getTags(): Observable<TagType[]> {
    return this.http.get<TagType[]>(`${environment.apiUrl}/Tag/tags`);
  }

  getTagsByUniverse(universeKey): Observable<TagType[]> {
    return this.http.get<TagType[]>(`${environment.apiUrl}/Tag/tags/${universeKey}`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  updateTagColor(tagKey: number, colorKey: number) {
    return this.http.post(`${environment.apiUrl}/Tag/UpdateTagColor/${tagKey}/${colorKey}`, null);
  }


  updateTagIsActive(tagKey: number, isActive: boolean) {
    return this.http.post(`${environment.apiUrl}/Tag/UpdateTagIsActive/${tagKey}/${isActive}`, null);
  }

  updateTagTypeIsActive(tagTypeKey: number, isActive: boolean) {
    return this.http.post(`${environment.apiUrl}/Tag/UpdateTagTypeIsActive/${tagTypeKey}/${isActive}`, null);
  }

  addTag(tag: Tag) {
    return this.http.post(`${environment.apiUrl}/Tag/CreateOrUpdateTag`, tag);
  }

  addCategoryTag(category: TagType) {
    return this.http.post(`${environment.apiUrl}/Tag/CreateOrUpdateTagType`, category);
  }

  addCategoryTagUniverse(category: TagType) {
    const formData = new FormData();
    formData.append('tagTypeString', JSON.stringify(category));
    return this.http.post(`${environment.apiUrl}/Tag/CreateOrUpdateTagTypeUniverse`, formData);
  }

  updateCategoryTagUniverse(category: TagType) {
    const formData = new FormData();
    formData.append('tagTypeString', JSON.stringify(category));
    return this.http.put(`${environment.apiUrl}/Tag/CreateOrUpdateTagTypeUniverse`, formData);
  }
}
